<template>
  <keep-alive include="QuickNav">
    <component :is="currentComponents" @toggle="toggle" />
  </keep-alive>
</template>
<script>
import QuickNav from "./quickNav.vue";
import PluginTools from "./pluginTools";
export default {
  name: 'quickNav',
  components: { QuickNav, PluginTools },
  data() {
    return {
      currentComponents: 'QuickNav'
    }
  },
  created() { },
  methods: {
    toggle(data) {
      this.currentComponents = data.name;
    },
  },
}
</script>
<style scoped lang="less"></style>
